/**
 * Runs on initial page load, setting the user object in the database if the user is logged in.
 */
export default async ({ app: { store, $auth } }) => {
    if ($auth.loggedIn) {
        await store.dispatch('user/setUser', $auth.user);
    }
};
